export default __webpack_public_path__ + "static/714-a65d47f49da3f56074139e1e4f149eab.gif";